import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment as env } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class MultiformatoService {

  private baseUrl = `${env.apiCerberoUrl}`;
  private apiKey = `${env.apiKey}`; 

  constructor(private http: HttpClient) {}

  generarMultiformato(payload: any): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    

    console.log('Payload enviado a multiformato:', payload);

    return this.http.post(
      `${this.baseUrl}/request?event=multiformato-generar-texto`,
      payload,
      { headers }
    );
  }
}
